import type { FC, ReactNode } from 'react'
import type { ContactLinkIcon } from '@/lib/contact-links'

import {
    FileDown,
    Instagram,
    Linkedin,
    Mail
} from 'lucide-react'

interface LinkIconProps {
    type: ContactLinkIcon
    className?: string
}

const ICONS = {
    mail: Mail,
    linkedin: Linkedin,
    instagram: Instagram,
    cv: FileDown
}

export const LinkIcon: FC<LinkIconProps> = ({ type, className }): ReactNode => {
    const Icon = ICONS[type]

    return <Icon aria-hidden='true' className={className} />
}
